<template>
  <div>
    <div class="d-flex w-100 mb-2">
      <span class="font-weight-bold" style="min-width: 40px">City: </span>
      <div class="flex-fill">
        <div class="d-flex w-100 mb-1" v-for="item in guiasCity" :key="item.id">
          <span class="flex-fill">{{ item.nombre }}</span>
        </div>
      </div>
    </div>
    <div class="d-flex w-100">
      <span class="font-weight-bold" style="min-width: 40px">Valle: </span>
      <div class="flex-fill">
        <div
          class="d-flex w-100 mb-1"
          v-for="item in guiasValle"
          :key="item.id"
        >
          <span class="flex-fill">{{ item.nombre }}</span>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 mt-2" v-if="idModule == 2">
      <span class="font-weight-bold" style="min-width: 40px">MaPi: </span>
      <div class="flex-fill">
        <div class="d-flex w-100 mb-1" v-for="item in guiasMaPi" :key="item.id">
          <span class="flex-fill">{{ item.nombre }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    num: Number,
    idModule: Number,
    month: String,
    calendario: Array,
  },
  data() {
    return {
      containers: {
        day: this.$dayjs(`${this.month}-${this.num}`, "YYYY-MM-D").format(
          "YYYY-MM-DD"
        ),
        guias: this.guias,
        meGuias: [],
      },
    };
  },
  created() {
    const vm = this;
    const meGuias = [];
    vm.calendario.forEach((item) => {
      if (item.fecha == vm.containers.day) {
        item.guiasNombres.forEach((item2) => {
          meGuias.push({
            ...item2,
            idServicio: item.servicio,
          });
        });
      }
    });

    vm.containers.meGuias = meGuias;
  },
  computed: {
    guiasCity() {
      return this.containers.meGuias.filter((item) => item.idServicio == 1);
    },
    guiasValle() {
      return this.containers.meGuias.filter((item) => item.idServicio == 2);
    },
    guiasMaPi() {
      return this.containers.meGuias.filter((item) => item.idServicio == 3);
    },
  },
};
</script>